export default __webpack_public_path__ + "static/media/ConeIcon.9a620d1c.svg";